<template>
  <div class='cpx'>
    <!-- 未开始用 -->
    <el-form :model="formData" label-width="100px" ref='formData' inline 
      v-if="status === 1">
      <el-form-item label="项目标题" prop='cpx_order_name'>
        <el-input v-model.trim="formData.cpx_order_name" class='w-210' clearable></el-input>
      </el-form-item>
      <el-form-item label="推广形式" prop='promote_video'>
        <el-select v-model="formData.promote_video" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in promote_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="落地平台" prop='cpx_client_target_location'>
        <el-select v-model="formData.cpx_client_target_location" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in luodi_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="结算模式" prop='settlement_source'>
        <el-select v-model="formData.settlement_source" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in settlement_source_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作模式" prop='cooperative'>
        <el-select v-model="formData.cooperative" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in cooperative_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报名截止时间" prop='time_ary'>
        <el-date-picker
          class="w-210"
          :default-time="['00:00:00', '23:59:59']"
          v-model="formData.time_ary"
          :editable="false"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="timeChange($event,'sign_up_time_s','sign_up_time_e')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="预计推广时间" prop='time_ary_1'>
        <el-date-picker
          class="w-210"
          :default-time="['00:00:00', '23:59:59']"
          v-model="formData.time_ary_1"
          :editable="false"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="timeChange($event,'expect_begin_time','expect_end_time')"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <!-- 进行中和已完成用 -->
    <el-form :model="formData" label-width="100px" ref='formData' inline
      v-if="status === 2 || status === 3">
      <el-form-item label="项目标题" prop='cpx_order_name'>
        <el-input v-model.trim="formData.cpx_order_name" class='w-210' clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="落地平台" prop='cpx_client_target_location'>
        <el-select v-model="formData.cpx_client_target_location" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in luodi_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="达人平台" prop='kol_platform'>
        <el-select v-model="formData.kol_platform" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in platform_list" :key="index" :label="item.platform_name" :value="item.klpmid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作达人" prop='klurid'>
        <el-select v-model="formData.klurid" placeholder="请选择" class='w-210'
          filterable
          remote
          :remote-method="getKol"
          clearable>
          <el-option v-for="(item, index) in srptid_list" :key='index' :label="item.nickname" :value="item.klurid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="达人推广时间" prop='time_ary_2'>
        <el-date-picker
          class="w-210"
          :default-time="['00:00:00', '23:59:59']"
          v-model="formData.time_ary_2"
          :editable="false"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="timeChange($event,'kol_time_begin_s','kol_time_begin_e')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="报名截止时间" prop='time_ary'>
        <el-date-picker
          class="w-210"
          :default-time="['00:00:00', '23:59:59']"
          v-model="formData.time_ary"
          :editable="false"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="timeChange($event,'sign_up_time_s','sign_up_time_e')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结算模式" prop='settlement_source'>
        <el-select v-model="formData.settlement_source" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in settlement_source_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合作模式" prop='cooperative'>
        <el-select v-model="formData.cooperative" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in cooperative_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="推广形式" prop='promote_video'>
        <el-select v-model="formData.promote_video" placeholder="请选择" class='w-210' clearable>
          <el-option v-for="(item, index) in promote_list" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div>
        <el-button type='primary' @click="getData(status)" style="margin-left: 100px">搜索</el-button>
        <el-button @click='clearAll'>重置</el-button>
    </div>
    <!-- table -->
    <div class='mt-10'>
      <el-table :data="list">
        <el-table-column label="合作信息">
          <template slot-scope="scope">
            <div>项目标题：{{ scope.row.cpx_order_name }}</div>
            <div>合作联系人：{{ scope.row.order_adid_name }}</div>
            <div>创建时间：{{ scope.row.create_time }}</div>
            <div class="tag-area">
              <div>推广形式：</div>
              <div>
                <span class="tag" v-if="scope.row.promote_video === 2">短视频</span>
                <span class="tag" v-if="scope.row.promote_live === 2">直播混播</span>
                <span class="tag" v-if="scope.row.promote_live_special === 2">直播专场</span>
                <span class="tag" v-if="scope.row.promote_other === 2">其他(图文等)</span>
              </div>
            </div>
            <div>
              <span>可供样品数：</span>
              <span v-if="scope.row.cpx_client_sample == 1">足量</span>
              <span v-if="scope.row.cpx_client_sample == 2">{{ scope.row.cpx_client_sample_num }}个</span>
              <span v-if="scope.row.cpx_client_sample == 3">无</span>
            </div>
            <div class="tag-area">
              <div>佣金方式：</div>
              <div>
                <span class="tag" v-if="scope.row.cpx_client_commission_target === 2">定向</span>
                <span class="tag" v-if="scope.row.cpx_client_commission_general === 2">通用</span>
                <span class="tag" v-if="scope.row.cpx_client_commission_sale === 2">营销</span>
              </div>
            </div>
            <div>推广预算：{{ scope.row.budget_money }}</div>
          </template>
        </el-table-column>
        <el-table-column label="合作计划">
          <template slot-scope="scope">
            <div>合作商品：</div>
            <div>合计：{{scope.row.order_goods_count && scope.row.order_goods_count.total}}</div>
            <div class="tag-area">
              <div>合作模式：</div>
              <div>
                <span class="tag" v-if="scope.row.cps === 2">CPS</span>
                <span class="tag" v-if="scope.row.cpt_goods === 2">CPT带货</span>
                <span class="tag" v-if="scope.row.cpt_recommended === 2">CPT种草</span>
                <span class="tag" v-if="scope.row.cpa === 2">CPA</span>
                <span class="tag" v-if="scope.row.cpc === 2">CPC</span>
              </div>
            </div>
            <div v-if="scope.row.settlement_source==2">结算模式：非联盟（合同等）</div>
            <div v-if="scope.row.settlement_source==1">结算模式：联盟（星任务/京任务）</div>
            <div>报名截止时间：<span :class="status === 1 ? 'p-color': ''">{{ scope.row.sign_up_time.slice(0, 10) }}</span></div>
            <div v-if="status === 1">预计推广时间：
              <div :class="status === 2 ? 'p-color': ''">{{scope.row.expect_begin_time.slice(0, 10) + ' 至 ' + scope.row.expect_end_time.slice(0, 10)}}</div>
            </div>
            <div v-if="status === 2 || status === 3">达人推广时间：
              <div v-if="scope.row.kol_time_begin !== null && scope.row.kol_time_end !== null"
              :class="status === 2 ? 'p-color': ''">{{ scope.row.kol_time_begin.slice(0, 10) + ' 至 ' + scope.row.kol_time_end.slice(0, 10) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div v-if="status === 3">
              <span>任务状态：</span>
              <span class="p-color"
                v-if="scope.row.status === 1 || scope.row.status === 2 ||
                scope.row.status === 3 || scope.row.status === 4 ||
                scope.row.status === 5 || scope.row.status === 7 || 
                scope.row.status === 8">合作延期</span>
              <span class="p-color" v-if="scope.row.status === 6">待交付</span>
              <span class="p-color" v-if="scope.row.status === 9">合作成功</span>
              <span class="p-color" v-if="scope.row.status === 10 || scope.row.status === 11">合作失败</span>
            </div>
            <div v-if="status === 2">任务状态：<span class="p-color">进行中</span></div>
            <div v-if="status === 1">项目状态：进行中</div>
            <div v-if="status === 1">报名状态：
              <span :class="scope.row.sign_up_time_status=='报名中'?'p-color':'p-color-danger'">{{ scope.row.sign_up_time_status }}</span>
            </div>
            <div v-if="scope.row.settlement_source !== 1 && status === 1">
              <span>达标情况：</span>
              <span v-if="scope.row.check_complete === 1">达标</span>
              <span v-if="scope.row.check_complete === 2">
                <span>不达标</span>
                <el-tooltip :content="scope.row.check_complete_reason" popper-class="item-tooltip" effect="dark" placement="top">
                  <i class="p-color-danger el-icon-question"></i>
                </el-tooltip>
              </span>
            </div>
            <div v-if="status === 1">推荐达人：{{ scope.row.cpx_order_kol_count.total }}</div>
            <div v-if="status === 1">待审核达人：{{scope.row.cpx_order_kol_count.to_add_coop}}</div>
            <div v-if="status === 1">已拒绝达人：{{scope.row.cpx_order_kol_count.deny}}</div>
            <div v-if="status === 1">选定合作达人：{{scope.row.cpx_order_kol_count.other}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" v-if='status==1'>
          <template slot-scope="scope">
            <el-button class='btn' plain>添加意向达人</el-button>
            <el-button class='btn' plain>选择达人</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="商品信息" v-if='status === 2 || status === 3'>
          <template slot-scope="scope">
            <div class="tag-area" v-for="(item, index) in scope.row.kol_goods_info" :key="index">
              <div>
                <el-image style="width: 40px; height: 40px; margin-right: 10px;" 
                  :src="item.goods_img" ></el-image>
              </div>
              <div>商品名称：
                <div>{{ item.goods_name }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="达人信息" v-if='status==2||status==3'>
          <template slot-scope="scope">
            <el-image style="width: 20px; height: 20px" 
              :src="scope.row.head_portrait" 
              :preview-src-list="addSrc(scope.row.head_portrait)"></el-image>
            <div>达人ID: {{ scope.row.klurid }}</div>
            <div>平台：{{ scope.row.type_name }}</div>
            <div>
              <span>达人昵称：</span>
              <span>{{ scope.row.nickname }}</span>
            </div>
            <div>达人号：{{ scope.row.id }}</div>
            <div>粉丝数：{{ scope.row.fans === "" ? 0 : scope.row.fans }}</div>
            <div v-if="scope.row.sex === 1">性别：男</div>
            <div v-if="scope.row.sex === 2">性别：女</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 页码 -->
    <el-row v-if="count">
      <div class="page">
        <div class="fz-13">
          <span>第</span>
          <span class="ml-4 mr-4">{{page.page}}</span>
          <span>页</span>
        </div>
        <div>
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="getData(status)"
              :current-page.sync="page.page"
              :page-size="page.offset"
              :page-sizes="[10, 20, 30, 40]"
              layout="total,sizes,prev, pager, next, jumper"
              :total="count"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-row>
    <!-- 返回顶部 -->
    <!-- <el-backtop target="#app">
      <i class="el-icon-caret-top"></i>
    </el-backtop> -->
    <!-- 弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="notlist"
      :close-on-click-modal='false'
      width="520px">
      <span>没有搜索到该条件合作，看看其他页面？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notlist = false">先不了</el-button>
        <el-button type="primary" @click="goOtherpage">去看看</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="alllist"
      :close-on-click-modal='false'
      width="520px">
      <div>您没有符合该条件的合作</div>
      <div>有任何疑问请咨询您的招商人员</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="alllist=false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import api from '../../../../xingluo_yunying/src/config/api';
export default {
  props:{
    status: null
  },
  name: 'cpxlist',
  data(){
    return{
      count: 0,
      page:{
        page: 1,
        offset: 20
      },
      formData:{
        cpx_order_name:'',
        expect_begin_time: '', // 预计推广时间
        expect_end_time: '',
        sign_up_time_s: '',  // 报名截止时间
        sign_up_time_e: '',
        kol_time_begin_s: '', // 达人推广时间
        kol_time_begin_e: '', // 达人推广时间
        settlement_source: '', // 结算模式
        cooperative: '',  // 合作模式
        promote_video: '',  // 推广形式
        // cpx_client_target_location: '',  // 落地平台
        klurid: '',  // 合作达人
        kol_platform: '',  // 达人平台
        time_ary: '',
        time_ary_1: '',
        time_ary_2: '',
      },
      platform_list: [], // 达人平台下拉
      srptid_list:[],  // 合作达人下拉
      settlement_source_list:[  // 结算模式下拉
        { label: "联盟（星任务/京任务）", value: 1 },
        { label: "非联盟（合同等）", value: 2 }
      ],
      cooperative_list:[  // 合作模式
        { label: "CPS", value: 1 },
        { label: "CPT带货", value: 2 },
        { label: "CPT种草", value: 3 },
        { label: "CPA", value: 4 },
        { label: "CPC", value: 5 }
      ],
      promote_list:[  // 推广形式
        { label: "短视频", value: 1 },
        { label: "直播混播", value: 2 },
        { label: "直播专场", value: 4 },
        { label: "其他(图文等)", value: 3 }
      ],
      luodi_list:[  // 落地平台
        { label: "淘宝", value: "tb" },
        { label: "天猫", value: "tm" },
        { label: "京东自营", value: "jd" },
        { label: "京东pop", value: "jdpop" },
        { label: "其他", value: "other" }
      ],
      list:[],
      status1: 0,
      flag: 1,
      notlist: false,
      alllist: false,
      api: {
        cpxOrderList: "/home/CpxOrderList",  // 未开始合作
        cxpDealList: "/home/cpxKolDealList",  // 进行中/已完成
        cpxKolList: "/home/cpxKolList",  // 获取达人
        getKolPlatformList: "/home/getKolPlatformList"  // 达人平台
      }
    }
  },
  created(){
    this.getKolPlatformList();
    this.getKol();
    this.getData(this.status);
  },
  methods:{
    // 达人平台列表
    getKolPlatformList(){
      this.$http.get(this.api.getKolPlatformList, {}).then(res => {
        if (res.code === 1) {
          this.platform_list = res.data.list
        } else {
          this.$message.error(res.msg)
        }
      });
    },
    // 获取达人
    getKol (name) {
      this.$http.get(this.api.cpxKolList, { nickname: name }).then(res => {
        if (res.code === 1) {
          this.srptid_list = res.data.list
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 重置 
    clearAll(){
      this.$refs["formData"].resetFields();
      this.formData.expect_begin_time = "";
      this.formData.expect_end_time = "";
      this.formData.sign_up_time_s = "";
      this.formData.sign_up_time_e = "";
      this.formData.kol_time_begin_s = "";
      this.formData.kol_time_begin_e = "";
      for(let key in this.$route.params){  // 清空页面跳转携带的参数
        delete this.$route.params[key];
      }
      this.getData(this.status);
    },
    // 时间拆分
    timeChange(event, _start, _end){
      this.formData[_start] = (event && event[0]) || "";
      this.formData[_end] = (event && event[1]) || "";
    },
    // 获取数据
    getData(status){
      let apiUrl = "";
      this.status1 = status;
      if (JSON.stringify(this.$route.params) !== "{}") {
        this.formData = this.$route.params
      }
      if (this.status1 === 1) {
        apiUrl = this.api.cpxOrderList;
      }
      if (this.status1 === 2) {
        apiUrl = this.api.cxpDealList;
        this.formData.cpx_type = 1;  // 进行中
      }
      if (this.status1 === 3) {
        apiUrl = this.api.cxpDealList;
        this.formData.cpx_type = 2;  // 未完成
      }
      this.$http.get(apiUrl, {
        params: {
          ...this.page,
          ...this.formData,
        }
      }).then(res => {
        if (res.code === 1) {
          this.count = res.data.count;
          this.list = res.data.list;
          if (this.status !== this.status1) {
            this.flag++;
          } else {
            this.flag = 1;
          }
          if (res.data.list && res.data.list.length === 0 && this.flag === 3) {
            this.alllist = true;
            this.notlist = false;
          } else if (res.data.list && res.data.list.length === 0 && this.flag === 2) {
            if (this.formData.klurid === "" && this.formData.kol_platform === "" &&
            this.formData.kol_time_begin_s === "" && this.formData.kol_time_begin_e === "") {
              this.goOtherpage();
            } else {
              this.alllist = true;
              this.notlist = false;
            }
          } else if (res.data.list && res.data.list.length === 0 && this.flag === 1) {
            if (this.formData.expect_begin_time === "" && this.formData.expect_end_time === "") {
              this.notlist = true;
            } else {
              this.notlist = false;
              this.alllist = true;
            }
          }
          if (res.data.list && res.data.list.length !== 0) {
            if (this.status !== this.status1) {
              switch(this.status1){
                case 1:
                  this.$router.push({
                    name: "cpxprogress",
                    params: {...this.formData}
                  });
                  break;
                case 2:
                  this.$router.push({
                    name: "cpxruning",
                    params: {...this.formData}
                  });
                  break;
                case 3:
                  this.$router.push({
                    name: "cpxend",
                    params: {...this.formData}
                  });
                  break;
              }
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    addSrc (url) {
      let srcArr = [];
      srcArr.push(url);
      return srcArr;
    },
    // 分页改变
    handleSizeChange(pageSize){
      this.page.offset = pageSize;
      this.getData(this.status);
    },
    //去到其他页面
    goOtherpage(){
      switch(this.status1){
        case 1:
          if (this.formData.expect_begin_time === "" && this.formData.expect_end_time === "") {
            this.getData(2);
          }
          break;
        case 2:
          this.getData(3);
          break;
        case 3:
          if (this.formData.klurid === "" && this.formData.kol_platform === "" &&
            this.formData.kol_time_begin_s === "" && this.formData.kol_time_begin_e === "") {
            this.getData(1);
          } else {
            this.getData(2);
          }
          break;
      }
    }
  }
}
</script>

<style scoped>
.w-210{
    width:210px;
}
.cpx{
  padding-top:25px;
  position: relative;
}
.mt-10{
    margin-top:10px;
}
.btn-area {
  text-align: center;
}
.btn{
    width:110px;
    margin:0 0 10px 0;
}
.page{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:20px 0;
}
.mr-4 {
  margin-right: 4px;
}
.ml-4 {
  margin-left: 4px;
}
.tag-area {
  display: flex;
}
.tag {
  display: block;
}
.p-color {
  color: #6435e8;
}
.p-warning {
  color: #E6A23C;
}
.p-color-succ {
  color: #67C23A;
}
.p-color-danger {
  color: #F56C6C;
}
.item-tooltip {
  max-width: 200px !important;
}
.p-text-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.project_name_btn {
  width: 100px;
  padding: 5px;
  margin: 0 5px 5px 0;
}
</style>
<style>
.cpx .el-table td, 
.cpx .el-table th {
  vertical-align: top !important;
}
</style>